import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
	'/_auth/company/$companyId/$campaignId/candidates/$candidateId/emails/$emailId',
)({
	component: RouteComponent,
})

// This route just provides the $emailId param.
// The parent route reads it via useMatches() and passes it to CandidateCard.
function RouteComponent() {
	return null
}
